import { render, staticRenderFns } from "./TestsSection.vue?vue&type=template&id=4511820f&scoped=true&"
import script from "./TestsSection.vue?vue&type=script&lang=js&"
export * from "./TestsSection.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/adminSection.css?vue&type=style&index=0&id=4511820f&prod&scoped=true&lang=css&"
import style1 from "./TestsSection.vue?vue&type=style&index=1&id=4511820f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4511820f",
  null
  
)

export default component.exports